<template>
    <article class="media note">
        <figure class="media-left">
            <p class="image is-32x32">
                <img :src="userAvatarById(note.actor_id)" class="note-avatar" alt="">
            </p>
        </figure>
        <div class="media-content">
            <div class="content">
                <strong>{{ actorNameByNote(note) }}</strong>
                <small>{{ $filters.note_date(note.created_at) }}</small>
                <a href="#" @click.prevent="send" :class="{'not-active': sending}">Resend</a>
                <button class="delete" @click.prevent="handleRemove"/>
                <div>
                    <span v-if="note.subject">
                        <strong>Subject: </strong>{{ note.subject }}&nbsp;
                    </span>
                    <label v-if="note.reference_type === 'project'" style="cursor: pointer;">
                        <strong>Is Milestone:&nbsp;</strong>{{ note.is_milestone ? 'Yes' : 'No' }}

                        <o-checkbox v-show="false" :true-value="1" v-model="note.is_milestone" @input="handleUpdate">
                            <!--Milestone-->
                        </o-checkbox>
                    </label>
                </div>

                <div class="break-word" v-html="note.message"></div>
            </div>
            <ul v-if="files.length">
                <li v-for="(file, key) in files" :key="key">
                    <span class="icon is-small">
                        <i class="fa fa-file"/>
                    </span>
                    <a :href="file.path" target="_blank">{{ file.name }}</a>
                    <span>{{ $filters.readableSize(file.size) }}</span>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>
    import HandlesForm from './../mixins/HandlesForm'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        mixins: [HandlesForm],

        props: ['id'],

        data() {
            return {
                sending: false
            }
        },

        computed: {
            ...mapGetters([
                'filesByReference',
                'actorNameByNote',
                'userAvatarById',
                'userNameById',
                'noteById'
            ]),

            note() {
                return this.noteById(parseInt(this.id))
            },

            files() {
                return this.filesByReference('note', this.note.id)
            }
        },

        methods: {
            ...mapActions(['updateNote', 'removeNote']),

            handleUpdate: _.debounce(function () {
                this.updateNote(this.note)
            }, 1000),

            send() {
                // @TODO: if a note is in the process of resending, disable resend button
                this.$emit('resend', this.note)
            },

            handleRemove() {
                this.confirmMessage(
                    'Deleting Note',
                    'Are you sure you want to <strong>delete</strong> this note? This action cannot be undone.',
                    'Delete Note'
                ).then(() => {
                    this.removeNote(this.note)
                })
            }
        }
    }
</script>
<style>
.note.media {
  border-top: none;
  margin-top: 10px;
  padding-top: 0px; }
  .note.media .media-left {
    margin-right: 0px;
    padding: 8px 5px 10px 2px; }
  .note.media .content {
    border: solid 1px #ccc;
    border-radius: 0px 6px 10px 6px;
    padding: 4px;
    background-color: #fff; }
  .note.media .delete {
    float: right; }

</style>